import * as tf from '@tensorflow/tfjs';
import {KNeighborsRegressor, setBackend} from '@/vendor/scikitjs/dist/es5'
import $ from "jquery";

export default class AIAutoCorrectV2 {
    constructor() {
        setBackend(tf)

        this.blockName = 'AIAutoCorrectV2';
        this.modelFavourNeutrality = null;
        this.modelFavourContext = null;
        this.img_size = 64;
        this.lut_size = 8;

        this.opacity = {
            minValue: 0,
            maxValue: 100,
        };
    }

    async addBlock(blockNum = lutify.blocks.length, data) {
        UI.createAdjustmentBlockTemplate("ai-auto-correct-v2", blockNum);
        let element = UI.getAdjustmentBlock(blockNum);
        this.addRegenerateButton($(element));
        UI.removeBlockBlendingModes($(element));
        UI.appendBlockLoadingSpinner($(element))

        await this.loadModel();
        $(element).find(".expand_options").trigger("click", [false]);

        $(element).find(".opacity_slider, .custom_opacity_slider").on("input", e => this.opacitySliderHandler($(element), e));
        $(element).find(".opacity-input, .custom-opacity-input").on("change", e => this.opacityInputHandler($(element), e));

        $(element).find(".btn-reset-block").on("click", e => {
            e.stopPropagation();
            this.resetBlock($(element));
        });

        $(element)
            .find('[data-control="favor-neutrality"]')
            .on("change", async e => {
                blocks.checkSwitchHandler($(element));

                lutify.getActiveBlock().favourNeutrality = e.target.checked;
                lutify.getActiveBlock().favourContext = !e.target.checked;
                $(element).find('[data-control="favor-neutrality"]').prop('checked', e.target.checked);
                $(element).find('[data-control="favor-context"]').prop('checked', !e.target.checked);

                let predictions = {};

                if (lutify.getActiveBlock().predictions[0] && lutify.getActiveBlock().predictions[1]) {
                    predictions = {
                        neutrality: {
                            lutFile: lutify.getActiveBlock().predictions[0],
                            lutContent: lutify.getActiveBlock().predictionsContent[0]
                        },
                        context: {
                            lutFile: lutify.getActiveBlock().predictions[1],
                            lutContent: lutify.getActiveBlock().predictionsContent[1]
                        }
                    }
                } else {
                    predictions = await this.predict();
                    this.storePredictions(predictions)
                }

                const lutFile = lutify.getActiveBlock().favourContext ? predictions.context.lutFile : predictions.neutrality.lutFile;
                this.apply(lutFile);
            })

        $(element)
            .find('[data-control="favor-context"]')
            .on("change", async e => {
                blocks.checkSwitchHandler($(element));

                lutify.getActiveBlock().favourContext = e.target.checked;
                lutify.getActiveBlock().favourNeutrality = !e.target.checked;
                $(element).find('[data-control="favor-context"]').prop('checked', e.target.checked);
                $(element).find('[data-control="favor-neutrality"]').prop('checked', !e.target.checked);

                let predictions = {};

                if (lutify.getActiveBlock().predictions[0] && lutify.getActiveBlock().predictions[1]) {
                    predictions = {
                        neutrality: {
                            lutFile: lutify.getActiveBlock().predictions[0],
                            lutContent: lutify.getActiveBlock().predictionsContent[0]
                        },
                        context: {
                            lutFile: lutify.getActiveBlock().predictions[1],
                            lutContent: lutify.getActiveBlock().predictionsContent[1]
                        }
                    }
                } else {
                    predictions = await this.predict();
                    this.storePredictions(predictions)
                }

                const lutFile = lutify.getActiveBlock().favourContext ? predictions.context.lutFile : predictions.neutrality.lutFile;
                this.apply(lutFile);
            })

        blocks.add({
            name: this.blockName,
            passes: this.addPasses(),
            predictions: [],
            predictionsContent: [],
            blockNum,
            blendingMode: 0,
            blendingModeName: "Normal",
            opacity: 100,
            favourContext: true,
            favourNeutrality: false,
        });

        $(element).find('.header-container .switch input').trigger('click');

        UI.removeBlockLoadingSpinner($(UI.getActiveBlock()));

        if (data.initial) {
            if (data.multiProcess) {
                vm.$store.commit('UI/SET_NEURAL_FILM_AI_PROCESSING_STEP', 2)

                await new Promise(resolve => {
                    setTimeout(() => {
                        vm.$store.commit('UI/SET_NEURAL_FILM_AI_PROCESSING_STEP', 3)
                        resolve()
                    }, 300)
                })
            }

            const predictions = await this.predict();
            this.storePredictions(predictions)

            if (data.model === 'favor-neutrality') {
                lutify.getActiveBlock().favourContext = false
                lutify.getActiveBlock().favourNeutrality = true

                $(element).find('[data-control="favor-context"]').prop('checked', false);
                $(element).find('[data-control="favor-neutrality"]').prop('checked', true);
            }

            const lutFile = lutify.getActiveBlock().favourContext ? predictions.context.lutFile : predictions.neutrality.lutFile;
            this.apply(lutFile);
        }
    }

    addPasses() {
        let pass = gpu.createRenderPass();
        gpu.addPassToComposer(pass, "toMiddle");
        return [pass];
    }

    async loadModel() {
        if (this.modelFavourNeutrality && this.modelFavourContext) return;
        if (vm.$store.state.UI.AIAutoCorrect.isDownloading) {
            this.showDownloadProgress();
            return;
        }

        let storeData = await this.isModelDownloaded();

        if (!storeData) {
            vm.$store.dispatch('UI/setAIAutoCorrectDownloading', true);

            let response = await vm.$store.dispatch('Projects/fetchSystemFiles', {
                block: 'ai-auto-correct-v2'
            });

            this.showDownloadProgress();

            let progress = [];
            let promises = [];

            response.forEach((file, idx) => {
                promises.push(
                    vm.$store.dispatch("Files/fetchFromS3", {
                        url: file.presignedURL,
                        config: {
                            responseType: "blob",
                            onDownloadProgress: progressEvent => {
                                progress[idx] = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                            }
                        }
                    })
                )
            })

            let interval = setInterval(async () => {
                if (!progress.length) return;
                let totalProgress = progress.reduce((r, i) => (r + i)) / promises.length;

                if (totalProgress >= 100) {
                    clearInterval(interval);
                }

                vm.$store.dispatch('UI/setAIAutoCorrectDownloadProgress', totalProgress.toFixed());
            }, 50)

            let files = await Promise.all(promises);

            this.hideDownloadProgress();

            storeData = {
                favourNeutrality: {
                    model: new File([files[0]], response[0].name),
                    weights: [
                        new File([files[1]], response[1].name),
                        new File([files[2]], response[2].name),
                    ]
                },
                favourContext: {
                    model: new File([files[3]], response[3].name),
                    weights: [
                        new File([files[4]], response[4].name),
                        new File([files[5]], response[5].name),
                    ]
                }
            }

            vm.$store.dispatch('UI/setAIAutoCorrectDownloading', false);
            await window.blocksStore.setItem('AIAutoCorrectV2', storeData);
        }

        this.modelFavourNeutrality = await tf.loadLayersModel(
            tf.io.browserFiles([
                storeData.favourNeutrality.model,
                storeData.favourNeutrality.weights[0],
                storeData.favourNeutrality.weights[1]
            ])
        );

        this.modelFavourContext = await tf.loadLayersModel(
            tf.io.browserFiles([
                storeData.favourContext.model,
                storeData.favourContext.weights[0],
                storeData.favourContext.weights[1]
            ])
        );
    }

    storePredictions(predictions) {
        lutify.getActiveBlock().predictions[0] = predictions.neutrality.lutFile
        lutify.getActiveBlock().predictions[1] = predictions.context.lutFile

        lutify.getActiveBlock().predictionsContent[0] = predictions.neutrality.lutContent
        lutify.getActiveBlock().predictionsContent[1] = predictions.context.lutContent
    }

    async predict(imageURL = null, forward = true) {
        let blockNum = blocks.getBlockIndex_byBlockNum(lutify.getActiveBlock().blockNum);
        let passes = blocks.getAllPassesToBlock(blockNum);

        // check the image size for when using larged media sizes
        if (!imageURL) imageURL = lutify.getIDTLMTimage(passes, false); // getting the main canvas image with IDT LMT

        let imageElement = new Image();
        imageElement.src = imageURL;
        await imageElement.decode();

        let tensor = tf.browser.fromPixels(imageElement);

        tensor = tf.cast(tensor, 'float32');
        tensor = this.resize(tensor, this.img_size);
        let image = this.normalize(tensor);

        let image_reshaped = tf.reshape(image, [1, this.img_size, this.img_size, 3]);

        const targetNeutrality = await this.modelFavourNeutrality.apply(image_reshaped, {'training': true});
        const targetContext = await this.modelFavourContext.apply(image_reshaped, {'training': true});

        const {lutFile: lutFileNeutrality, lutContent: lutContentNeutrality} = await this.getLutFromTarget(targetNeutrality, image, forward);
        const {lutFile: lutFileContext, lutContent: lutContentContext} = await this.getLutFromTarget(targetContext, image, forward);

        return {
            neutrality: {
                lutFile: lutFileNeutrality,
                lutContent: lutContentNeutrality
            },
            context: {
                lutFile: lutFileContext,
                lutContent: lutContentContext
            }
        }
    }

    async getLutFromTarget(target, image, forward = true) {
        let LUT = forward ? await this.img_to_lut(image, tf.squeeze(target)) : await this.img_to_lut(tf.squeeze(target), image);
        let [r, g, b] = this.split_channels(LUT, 3, 1);

        let lutContent = "TITLE Created with fylm.ai AI Auto Correct\n"
        lutContent = lutContent + "LUT_3D_SIZE 8\n\n"
        for (let i = 0; i < this.lut_size * this.lut_size * this.lut_size; i++) {
            lutContent = lutContent + r[i].toFixed(6).toString() + " " + g[i].toFixed(6).toString() + " " + b[i].toFixed(6).toString() + "\n"
        }

        const lutFile = await this.createLutFileFromContent(lutContent);

        return {
            lutFile,
            lutContent
        }
    }

    async createLutFileFromContent(content) {
        const LUTFile = new File([content], "ai-auto-correct.cube", {type: "text/plain"});
        const loadedLUTs = await luts.load([LUTFile]);

        return loadedLUTs[0];
    }

    apply(LUT) {
        let pass = gpu.createLUTPass(LUT.texture);
        pass.uid = lutify.getActiveBlock().passes[0].uid;
        let index = gpu.getPassIndexById(lutify.getActiveBlock().passes[0].uid);
        gpu.composer.passes[index] = pass;
        lutify.getActiveBlock().passes[0] = pass;
        this.resetOpacity();
        gpu.render();
    }

    resize(input_image, size) {
        let output_image = tf.image.resizeNearestNeighbor(input_image, [size, size]);
        return output_image;
    }

    normalize(input_image) {
        let output_image = tf.sub(tf.div(input_image, 127.5), 1);
        return output_image;
    }

    async img_to_lut(input_image, target_image) {
        let target = tf.add(tf.mul(target_image, 0.5), 0.5)
        let input = tf.add(tf.mul(input_image, 0.5), 0.5)

        let t = tf.sub(target, input);
        let [tR, tG, tB] = this.split_channels(t, 3, 2);

        let [iR, iG, iB] = this.split_channels(input, 3, 2);
        let icolor = tf.stack([iR, iG, iB]).transpose();

        let a = this.lut_size - 1;
        let LUT = [];
        for (let k = 0; k < this.lut_size; k++) {
            for (let j = 0; j < this.lut_size; j++) {
                for (let i = 0; i < this.lut_size; i++) {
                    LUT.push([i / a, j / a, k / a]);
                }
            }
        }

        LUT = tf.stack(LUT)

        let interpolation = new KNeighborsRegressor(40, 'distance');
        await interpolation.fit(icolor, tR)
        let tRp = interpolation.predict(LUT);

        await interpolation.fit(icolor, tG)
        let tGp = interpolation.predict(LUT);

        await interpolation.fit(icolor, tB)
        let tBp = interpolation.predict(LUT);

        let [lutiR, lutiG, lutiB] = this.split_channels(LUT, 3, 1);
        lutiR = tf.add(lutiR, tRp);
        lutiG = tf.add(lutiG, tGp);
        lutiB = tf.add(lutiB, tBp);
        LUT = tf.stack([lutiR, lutiG, lutiB]).transpose();

        LUT = await tf.clipByValue(LUT, 0, 1);
        return LUT;
    }

    split_channels(tensor, num_splits, axis) {
        let [tR, tG, tB] = tf.split(tensor, num_splits, axis);
        tR = tR.dataSync();
        tG = tG.dataSync();
        tB = tB.dataSync();
        return [tR, tG, tB]
    }

    resetBlock($element) {
        if (lutify.getActiveBlock().favourNeutrality) {
            $element.find('[data-control="favor-context"]').trigger('click');
        }

        this.resetOpacity();
    }

    resetOpacity() {
        $(UI.getActiveBlock()).find(".opacity-input").val(100);
        $(UI.getActiveBlock()).find(".opacity-input").trigger("change");
    }

    opacitySliderHandler($element) {
        let opacityValue = $element.find(".opacity_slider").val();
        let calcOpacityValue = opacityValue * 0.01;

        $element.find(".opacity-input").val(opacityValue);

        lutify.getActiveBlock().opacity = opacityValue;
        lutify.getActiveBlock().passes[0].uniforms.opacity.value = calcOpacityValue;

        gpu.render();
    }

    opacityInputHandler($element) {
        let opacityValue = $element.find(".opacity-input").val();
        let opacitySlider = $element.find(".opacity_slider");

        if (opacityValue > this.opacity.maxValue) opacityValue = this.opacity.maxValue;
        if (opacityValue < this.opacity.minValue) opacityValue = this.opacity.minValue;

        opacitySlider.val(opacityValue);
        opacitySlider.trigger("input");
    }

    hideDownloadProgress() {
        vm.$snackbarHide()
    }

    showDownloadProgress() {
        vm.$snackbar(`Downloading AI model. This might take a while only the first time. `, "success", {
            timeout: -1,
            showAIAutoCorrectDownloadProgress: true,
        });
    }

    async isModelDownloaded() {
        let storeData = await window.blocksStore.getItem('AIAutoCorrectV2');
        return storeData;
    }

    addRegenerateButton($element) {
        let icon = document.createElement('i')
        icon.setAttribute('class', 'btn-block-regenerate material-icons')
        icon.setAttribute('data-tippy-content', 'Regenerate')
        icon.innerHTML = 'loop'
        icon.addEventListener('click', async () => {
            UI.appendBlockLoadingSpinner($element)

            const predictions = await this.predict();
            this.storePredictions(predictions)
            const lutFile = lutify.getActiveBlock().favourContext ? predictions.context.lutFile : predictions.neutrality.lutFile;
            this.apply(lutFile);

            UI.removeBlockLoadingSpinner($element)
        })
        $element.find('.header-container .controls-wrapper').prepend(icon)
    }

    async applyChanges($block, values, blockData) {
        lutify.getActiveBlock().favourContext = blockData.favourContext;
        lutify.getActiveBlock().favourNeutrality = blockData.favourNeutrality;
        $block.find('[data-control="favor-context"]').prop('checked', blockData.favourContext);
        $block.find('[data-control="favor-neutrality"]').prop('checked', blockData.favourNeutrality);

        let predictions = {};

        if (blockData.predictionsContent[0] && blockData.predictionsContent[1]) {
             predictions = {
                neutrality: {
                    lutFile: await this.createLutFileFromContent(blockData.predictionsContent[0]),
                    lutContent: blockData.predictionsContent[0]
                },
                context: {
                    lutFile: await this.createLutFileFromContent(blockData.predictionsContent[1]),
                    lutContent: blockData.predictionsContent[1]
                }
            }
        } else {
            predictions = await this.predict();
        }

        this.storePredictions(predictions)
        const lutFile = lutify.getActiveBlock().favourContext ? predictions.context.lutFile : predictions.neutrality.lutFile;
        this.apply(lutFile);

        $block.find(".opacity-input").val(parseInt(blockData.opacity));
        $block.find(".opacity-input").trigger("change");
    }
}
